const BASE_URL = '/live/api/v1/labor'

import { get,del } from '@/plugins/http'

export default {
  getLawExams: get(`${BASE_URL}/company`),
  deleteLawExam: del(`${BASE_URL}/{companyId}`),
  getExamURL: get(`${BASE_URL}/url`),
  downloadReport: get('live/api/v1/examination/report/word/labor'),
}